import axios from 'axios'

// 创建axios实例
const request = axios.create({
    // 这里可以放一下公用属性等。
    //baseURL: 'http://192.168.63.210:8080', // 用于配置请求接口公用部分，请求时会自动拼接在你定义的url前面。
    baseURL: 'http://39.108.228.33:28080/HuiYunAdmin/',
    timeout: 8 * 1000, // 请求超时时间
})

export default request;








































